<template>
  <div>
    <div class="form-group row">
      <div class="col-sm-6">
        <b-button variant="success" v-b-modal.modal-tambah-kabupaten
          ><span class="glyphicon glyphicon-plus mb-2" /> Tambah</b-button
        >
      </div>
      <div class="col-sm-6 text-end"></div>
    </div>
    <div class="role">
      <v-client-table
        :data="itemsWithNumber"
        :columns="columnsDatatable"
        :options="optionsDokumen"
      >
        <div slot="aksi" slot-scope="props">
          <b-button
            variant="info"
            class="me-3"
            size="s"
            @click="getDetail(props.row.id)"
          >
            <i class="glyphicon glyphicon-pencil text-white me-sm-1 mb-sm-2" />
            <span class="d-none d-md-inline-block text-white"> Edit</span>
          </b-button>
          <b-button
            style="margin-left: 5px"
            variant="danger"
            class="me-3"
            size="s"
            @click="deleteData(props.row.id)"
          >
            <i class="glyphicon glyphicon-trash text-white me-sm-1 mb-sm-2" />
            <span class="d-none d-md-inline-block text-white"> Hapus</span>
          </b-button>
        </div>
      </v-client-table>
    </div>

    <!-- modal tambah -->
    <b-modal
      body-class="bg-white"
      id="modal-tambah-kabupaten"
      scrollable
      title="Tambah Data"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-form-group label="Provinsi" label-for="provinsi" class="mb-3">
          <v-select
            id="default-select"
            v-model="form.id_provinsi"
            :reduce="(data) => data.id"
            label="nama_provinsi"
            :options="dataProvinsi"
            @input="selectProvinsi($event)"
            v-validate="'required'"
            name="provinsi"
            :class="{ 'is-invalid': errors.has('form-1.provinsi') }"
          />
          <span class="text-danger" v-if="errors.has('form-1.provinsi')">
            {{ errors.first("form-1.provinsi") }}
          </span>
        </b-form-group>
        <b-form-group label="ID Kabupaten" label-for="id" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="id"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.id'),
            }"
            id="name"
            v-model="form.id"
          />
          <span class="text-danger" v-if="errors.has('form-1.id')">
            {{ errors.first("form-1.id") }}
          </span>
        </b-form-group>
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="nama"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.nama'),
            }"
            id="name"
            v-model="form.nama_kabupaten"
          />
          <span class="text-danger" v-if="errors.has('form-1.nama')">
            {{ errors.first("form-1.nama") }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float: right" @click="onSubmit">
            <i class="fa fa-floppy-o text-white" />
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal tambah -->
    <b-modal
      body-class="bg-white"
      id="modal-edit-kabupaten"
      scrollable
      title="Edit Data"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form ref="form" @submit.stop.prevent="editData">
        <b-form-group label="Provinsi" label-for="provinsi" class="mb-3">
          <v-select
            id="default-select"
            v-model="form.id_provinsi"
            :reduce="(data) => data.id"
            label="nama_provinsi"
            :options="dataProvinsi"
            @input="selectProvinsi($event)"
            v-validate="'required'"
            name="provinsi"
            :class="{ 'is-invalid': errors.has('form-1.provinsi') }"
          />
          <span class="text-danger" v-if="errors.has('form-1.provinsi')">
            {{ errors.first("form-1.provinsi") }}
          </span>
        </b-form-group>
        <b-form-group label="ID Provinsi" label-for="id" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="id"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.id'),
            }"
            id="name"
            v-model="form.id"
          />
          <span class="text-danger" v-if="errors.has('form-1.id')">
            {{ errors.first("form-1.id") }}
          </span>
        </b-form-group>
        <b-form-group label="Nama" label-for="name" class="mb-3">
          <b-form-input
            v-validate="'required'"
            name="nama"
            :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.nama'),
            }"
            id="name"
            v-model="form.nama_kabupaten"
          />
          <span class="text-danger" v-if="errors.has('form-1.nama')">
            {{ errors.first("form-1.nama") }}
          </span>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            style="float: right"
            @click="editData(form.id)"
          >
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import vSelect from "vue-select";

export default {
  components: { vSelect },
  data() {
    return {
      dataKabupaten: [],
      columnsDatatable: ["no", "nama_provinsi", "nama_kabupaten", "aksi"],
      form: {},
      dataProvinsi: [],
      optionsDokumen: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { no: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },
    };
  },
  mounted() {
    this.loaddata();
    this.loadProvinsi();
  },
  computed: {
    itemsWithNumber() {
      return this.dataKabupaten.map((d, index) => ({ ...d, no: index + 1 }));
    },
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      },
    },
    baseapi: String,
  },
  methods: {
    selectProvinsi(e){
      const result = this.dataProvinsi.find(({ id }) => id === e);

      this.form.nama_provinsi = result.nama_provinsi
      console.log(result)
    },
    loaddata() {
      axios
        .get(this.baseapi + "api/kabupaten", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKabupaten = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    loadProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getDetail(id) {
      axios
        .get(this.baseapi + "api/kabupaten/" + id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
          this.$nextTick(() => {
            this.$bvModal.show("modal-edit-kabupaten");
          });
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    onSubmit() {
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          axios
            .post(
              this.baseapi + "api/kabupaten",
              {
                id_provinsi: this.form.id_provinsi,
                nama_provinsi: this.form.nama_provinsi,
                id: this.form.id,
                nama_kabupaten: this.form.nama_kabupaten,
              },
              {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Ditambah");
              this.loaddata();
              this.dataKabupaten = [];
              this.form = {};

              // Wait until the models are updated in the UI
              this.$nextTick(() => {
                this.$bvModal.hide("modal-tambah-kabupaten");
              });
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },

    editData(id) {
      this.$validator.validateAll();
      axios
        .put(
          this.baseapi + `api/kabupaten/${id}`,
          {
            // idptsp,
            id_provinsi: this.form.id_provinsi,
                nama_provinsi: this.form.nama_provinsi,
                id: this.form.id,
                nama_kabupaten: this.form.nama_kabupaten,
          },
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((res) => {
          this.$toasted.success("Berhasil Diubah");
          this.form = {};
          this.dataKabupaten = [];
          this.loaddata();

          this.$nextTick(() => {
            this.$bvModal.hide("modal-edit-kabupaten");
          });
          return res;
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.error(err.response.data.message);
          return err;
        });
    },

    deleteData(id) {
      Swal.fire({
        title: "Hapus Data?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + `api/kabupaten/` + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((res) => {
              this.$toasted.success("Berhasil Dihapus");
              this.loaddata();
              return res;
            })
            .catch((err) => {
              console.log(err);
              this.$toasted.error(err.response.data.message);
              return err;
            });
        }
      });
    },
  },
};
</script>